var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.656 5.719H3.344L1 23.53h30L28.656 5.72z",
    fill: "#E8DEF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 23.531 28.656 5.72H3.344L1 23.53m30 0H1m30 0-.938 3.75H1.938L1 23.531M11.313 25.406h1.406M4.75 25.406h1.406M14.125 25.406h1.406M16.938 25.406h1.406M19.75 25.406h1.406",
    stroke: "#510C76",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchImage);
export default __webpack_public_path__ + "static/media/switchImage.76f289a4f29c36c950c936420dd4768f.svg";
export { ForwardRef as ReactComponent };